import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Dokument} from '../../../../../models/dokument';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {SelectionModel} from '@angular/cdk/collections';
import {BehaviorSubject} from 'rxjs';

class DokumentNode extends Dokument{
  children: BehaviorSubject<DokumentNode[]>;
  constructor(public item: string,
              children?: DokumentNode[]) {
    super();
    this.children = new BehaviorSubject(children === undefined ? [] : children);
  }
}

@Component({
    selector: 'lv-dokument-tree-element',
    templateUrl: './dokument-tree-element.component.html',
    styleUrls: ['./dokument-tree-element.component.scss'],
    standalone: false
})
export class DokumentTreeElementComponent implements OnChanges {

  @Input()
  dokument: Dokument[];

  @Output()
  treeChanged: EventEmitter<Dokument[]> = new EventEmitter<Dokument[]>();

  @Input()
  downloadVerpflichtend: boolean;

  levels = new Map<DokumentNode, number>();
  treeControl: FlatTreeControl<DokumentNode>;

  treeFlattener: MatTreeFlattener<DokumentNode, DokumentNode>;

  public vorvertraglicheInformationenGewaehlt: boolean;

  dataSource: MatTreeFlatDataSource<DokumentNode, DokumentNode>;

  checklistSelection = new SelectionModel<DokumentNode>(true /* multiple */);


  constructor(private changeDetectorRef: ChangeDetectorRef) {


  }

  ngOnChanges() {
    const node = new DokumentNode('Alle Dokumente');


    const childArr: DokumentNode[] = [];

    this.dokument.forEach(element => {
      const dok = new DokumentNode(element.BeschreibungKurz);

      dok.Beschreibung = element.Beschreibung;
      dok.DokumentTyp = element.DokumentTyp;
      dok.BeschreibungKurz = element.BeschreibungKurz;
      dok.selected = element.selected;
      dok.VVGErforderlichJN = element.VVGErforderlichJN;

      childArr.push(dok);
      if (!!dok.selected) {
        this.checklistSelection.select(dok);
      }

    });

    if(!this.downloadVerpflichtend) {
      childArr.sort((a, b) => a.item.localeCompare(b.item));
    }


    node.children.next(childArr);


    const TREE_DATA = [node];

    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel,
        this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<DokumentNode>(
        this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = TREE_DATA;

    if (this.descendantsAllSelected(this.dataSource.data[0])) {
      this.dataSource.data[0].selected = true;
    }

    this.treeControl.expandAll();


  }

  onTreeChanged() {

    this.dokument.forEach(outputDok => {
      this.dataSource.data[0].children.value.forEach(editDocument => {
        if (outputDok.DokumentTyp === editDocument.DokumentTyp) {
          outputDok.selected = editDocument.selected;
        }
      });
    });
    this.treeChanged.emit(this.dokument);
  }

  getLevel = (node: DokumentNode): number => this.levels.get(node) || 0;

  isExpandable = (node: DokumentNode): boolean => node.children.value.length > 0;

  getChildren = (node: DokumentNode) => node.children;

  transformer = (node: DokumentNode, level: number) => {
    this.levels.set(node, level);
    return node;
  };

  hasChildren = (index: number, node: DokumentNode) => this.isExpandable(node);

  descendantsAllSelected(node: DokumentNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    if (!descendants.length) {
      return this.checklistSelection.isSelected(node);
    }
    const selected = this.checklistSelection.isSelected(node);
    const allSelected = descendants.every(child => this.checklistSelection.isSelected(child));
    if (!selected && allSelected) {
      this.checklistSelection.select(node);
      this.changeDetectorRef.markForCheck();
    }
    return allSelected;
  }

  checkboxSelected(node: DokumentNode) {
    return node.selected;
  }

  descendantsPartiallySelected(node: DokumentNode): boolean {
    const currentDokList = this.dataSource.data[0].children.value;
    const checkedDokList: DokumentNode[] = [];

    currentDokList.forEach(element => {
      if(element.selected) {
        checkedDokList.push(element);
      }
    });

    if(checkedDokList.length >= 1 && currentDokList.length !== checkedDokList.length) {
      return true;
    }

    if(checkedDokList.length < 1 || currentDokList.length === checkedDokList.length) {
      return false;
    }
  }

  nodeSelectionToggle(node: DokumentNode): void {
    this.vorvertraglicheInformationenGewaehlt = false;
    this.checklistSelection.toggle(node);
    const currentDokArray = this.dataSource.data[0].children.value;

    currentDokArray.forEach(element => {
      if (element.item === node.item) {
        element.selected = !element.selected;
      }
    });

    this.dataSource.data[0].children.next(currentDokArray);
    this.onTreeChanged();
    this.checkParentSelect();

  }

  selectAmAll() {
    this.vorvertraglicheInformationenGewaehlt = false;
    const currentDokArray = this.dataSource.data[0].children.value;

    if (!this.dataSource.data[0].selected) {

      currentDokArray.forEach(element => {
        element.selected = true;
      });

    }
    if (this.dataSource.data[0].selected) {

      currentDokArray.forEach(element => {
        element.selected = false;
      });

    }

    this.dataSource.data[0].selected =  !this.dataSource.data[0].selected;
    this.dataSource.data[0].children.next(currentDokArray);
    this.onTreeChanged();
    this.treeControl.expandAll();

  }

  checkParentSelect() {
    const currentDokList = this.dataSource.data[0].children.value;
    const checkedDokList: DokumentNode[] = [];

    currentDokList.forEach(element => {
      if(element.selected) {
        checkedDokList.push(element);
      }
    });

    if(checkedDokList.length === currentDokList.length) {
      this.dataSource.data[0].selected = true;
    }

    if(checkedDokList.length !== currentDokList.length) {
      this.dataSource.data[0].selected = false;
    }
  }

  selectDoksVorvertraglicheInformationen() {
    if (this.vorvertraglicheInformationenGewaehlt) {
      this.dataSource.data[0].children.value.forEach(element => {
        if (element.VVGErforderlichJN) {
          element.selected = true;
          this.checklistSelection.select(element);
        }
        if (!element.VVGErforderlichJN) {
          element.selected = false;
          this.checklistSelection.deselect(element);
        }
      });
    }
    if (!this.vorvertraglicheInformationenGewaehlt) {
      this.dataSource.data[0].children.value.forEach(element => {
        element.selected = true;
      });
    }

    this.checkParentSelect();
    this.onTreeChanged();
    this.treeControl.expandAll();
    this.dataSource.data[0].children.next(this.dataSource.data[0].children.value);
  }
}
